module.exports = __webpack_public_path__ + "static/img/zhuanli-bg.8709a4cc.png";